export interface ClientInfo {
    firstName: string;
    lastName: string;
    contactEmail: string;
    isPrimary: boolean;
    phoneNumber: string;
    dialCode: number;
    countryCode: string;
    isSecondaryIdRequired: boolean;
    isBankingVerificationRequired: boolean;
    customFileNumber?: string;
}

export function createEmptyClient(isPrimary: boolean): ClientInfo {
    return {
        firstName: '',
        lastName: '',
        contactEmail: '',
        isPrimary,
        phoneNumber: '',
        dialCode: 1,
        countryCode: 'ca',
        isSecondaryIdRequired: false,
        isBankingVerificationRequired: false,
        ...(isPrimary ? { customFileNumber: '' } : {}),
    };
}
